module.exports = __webpack_public_path__ + "static/background-d4414b0602fc7c2613c28c001214f65a.jpg";